module.exports = __webpack_public_path__ + "fonts/NuberNext-Regular.otf";